import type { Backend } from '@freelancer/datastore/core';
import { OrderByDirection } from '@freelancer/datastore/core';
import type { SecurityPhoneRequestsCollection } from './security-phone-requests.types';

export function securityPhoneRequestsBackend(): Backend<SecurityPhoneRequestsCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: () => ({
      endpoint: 'user/settings/securityPhoneRequest.php',
      isGaf: true,
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: () => ({
      endpoint: 'user/settings/securityPhoneRequest.php',
      isGaf: true,
      method: 'DELETE',
      payload: {},
    }),
  };
}
